// right now these only hold the brand colors, eventually they will hold the fonts etc
export const jacadaTheme = {
  secondary: '#C1AA7F',
};
